import { render, staticRenderFns } from "./SingleSlideComponent.vue?vue&type=template&id=fe5da880&scoped=true"
import script from "./SingleSlideComponent.vue?vue&type=script&lang=js"
export * from "./SingleSlideComponent.vue?vue&type=script&lang=js"
import style0 from "./SingleSlideComponent.vue?vue&type=style&index=0&id=fe5da880&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe5da880",
  null
  
)

export default component.exports